"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remoteVideoSourcesDidChangeHandler = remoteVideoSourcesDidChangeHandler;
var _logger = require("@studio/logger");
var _constants = require("../../../constants");
function remoteVideoSourcesDidChangeHandler(videoSources, meetingSession, meetingResponse) {
  var meetingId = meetingResponse.Meeting.MeetingId;
  var logPayload = {
    chimeEventName: 'remoteVideoSourcesDidChange',
    'studio.meeting.id': meetingId,
    title: "Remote video sources did change: ".concat(JSON.stringify(videoSources))
  };
  (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
}